import React, { useState, useContext, useEffect, useRef } from 'react';

function GradationWrap(props) {
  return (
    <div className='gradation-back'>
      {props.children}
    </div>
  );
}

export default GradationWrap;